// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/deployer/v1/endpoint_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateEndpointRequest, CreateEndpointResponse, DeleteEndpointRequest, DeleteEndpointResponse, GetEndpointRequest, GetEndpointResponse, ListEndpointsRequest, ListEndpointsResponse, UpdateEndpointRequest, UpdateEndpointResponse } from "@buf/h2oai_mlops-deployment.bufbuild_es/ai/h2o/mlops/deployer/v1/endpoint_service_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Manages endpoints.
 *
 * @generated from service ai.h2o.deploy.EndpointService
 */
export const EndpointService = {
  typeName: "ai.h2o.deploy.EndpointService",
  methods: {
    /**
     * Creates an endpoint.
     *
     * @generated from rpc ai.h2o.deploy.EndpointService.CreateEndpoint
     */
    createEndpoint: {
      name: "CreateEndpoint",
      I: CreateEndpointRequest,
      O: CreateEndpointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves a single endpoint.
     *
     * @generated from rpc ai.h2o.deploy.EndpointService.GetEndpoint
     */
    getEndpoint: {
      name: "GetEndpoint",
      I: GetEndpointRequest,
      O: GetEndpointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists endpoints.
     *
     * @generated from rpc ai.h2o.deploy.EndpointService.ListEndpoints
     */
    listEndpoints: {
      name: "ListEndpoints",
      I: ListEndpointsRequest,
      O: ListEndpointsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an endpoint.
     *
     * @generated from rpc ai.h2o.deploy.EndpointService.UpdateEndpoint
     */
    updateEndpoint: {
      name: "UpdateEndpoint",
      I: UpdateEndpointRequest,
      O: UpdateEndpointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an endpoint.
     *
     * @generated from rpc ai.h2o.deploy.EndpointService.DeleteEndpoint
     */
    deleteEndpoint: {
      name: "DeleteEndpoint",
      I: DeleteEndpointRequest,
      O: DeleteEndpointResponse,
      kind: MethodKind.Unary,
    },
  }
};

